/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */

import {
  GET_ASSET_INVESTMENT_INFO_SUCCESS,
  GET_ASSET_INVESTMENT_INFO_FAILURE,
  UPDATE_ASSET_INVESTMENT_INFO_SUCCESS,
  UPDATE_ASSET_INVESTMENT_INFO_FAILURE,
  RESET_INVESTMENT_INFO
} from "../actions/actionTypes";

const initialState = {
  investmentInfo: {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ASSET_INVESTMENT_INFO_SUCCESS:
      return {
        loadingInvestmentInfoSuccess: true,
        investmentInfo: action.payload.investmentInfo
      };

    case GET_ASSET_INVESTMENT_INFO_FAILURE:
      return {
        loadingInvestmentInfoSuccess: false,
        error: action.err.message,
        investmentInfo: state.investmentInfo
      };

    case UPDATE_ASSET_INVESTMENT_INFO_SUCCESS:
      return {
        updateInvestmentInfoSuccess: true,
        investmentInfo: action.payload.investmentInfo
      };

    case UPDATE_ASSET_INVESTMENT_INFO_FAILURE:
      return {
        updateInvestmentInfoSuccess: false,
        error: action.err.message,
        investmentInfo: state.investmentInfo
      };
    case RESET_INVESTMENT_INFO:
      return {};
    default:
      return state;
  }
}
